// Auto-generated translation for pt.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:08:51.360475+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Para proprietários de cavalos",
    title: "Tudo para o seu cavalo. Num só app.",
    subtitle: "Gira saúde, treino, planeamento e profissionais a partir de um único dossiê organizado.",
    primaryCTA: {
      label: "Começar grátis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Perfil do cavalo — peso, vacinação, EquiCoach, alimentação e treino num único ecrã",
      caption: "O seu cavalo, completo numa só vista.",
    },
    problem: "Provavelmente mantém consultas, fotos, treino, alimentação e saúde espalhados por vários sítios — grupos de WhatsApp, caixas de sapatos e apps separadas. O resultado é a falta de visão geral.",
    solution: "O EquiSight transforma o seu cavalo num dossiê digital completo que o acompanha para todo o lado.",
    benefits: [
      "Um perfil completo por cavalo",
      "Saúde, ferrador, dentista e fisioterapeuta num só lugar",
      "Agenda com lembretes inteligentes",
      "Fotos, notas e histórico sem limite",
      "Cópia de segurança de todos os seus dados com Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 cavalo · sempre grátis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Vários cavalos + cópia de segurança",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto para começar?",
      title: "Comece hoje com o seu primeiro cavalo.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Mais cavalos. Mais organização. Mais segurança.",
    subtitle: "Faça upgrade para o Premium e gerencie todos os seus cavalos sem limitações — com toda a inteligência do EquiCoach.",
    primaryCTA: {
      label: "Comece 14 dias grátis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Todos os preços",
      href: "/#pricing",
    },
    audience: "Para proprietários, cavaleiros desportivos e criadores com múltiplos cavalos.",
    features: [
      "Adicionar cavalos ilimitados",
      "Histórico completo por cavalo",
      "Backup de dados",
      "Insights avançados do EquiCoach",
      "Notificações e planeamento inteligentes",
      "Saúde e treino totalmente integrados",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Menos de €0,17 por dia",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Faça upgrade para o Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Para cavaleiros de centro hípico",
    title: "Evoluir, mesmo sem cavalo próprio.",
    subtitle: "Acompanha as tuas aulas, treinos e desenvolvimento dentro do EquiSight — por menos do que um café por mês para o papá ou a mamã. Ou um bom gelado com chantilly.",
    primaryCTA: {
      label: "Começar com Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Como funciona?",
      href: "#features",
    },
    problem: "Como cavaleiro de centro hípico, muitas vezes não tens cavalo próprio, mas ainda assim queres crescer e ter uma visão clara das tuas aulas, objetivos e dos cavalos em que montas.",
    solution: "A funcionalidade de centro hípico está incluída de série no Premium — acompanha o teu próprio desenvolvimento e consulta os cavalos do centro em modo só de leitura.",
    features: [
      "Registar treinos",
      "Definir objetivos",
      "Acompanhar progressão",
      "Ver cavalos do centro com nome e foto",
      "Sem acesso a dados de saúde privados",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mês · funcionalidade de centro hípico incluída",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Torna-te membro",
      title: "Começa como cavaleiro de centro hípico.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Para picadeiros & estábulos",
    title: "Torne o seu picadeiro digitalmente acessível para cada cavaleiro.",
    subtitle: "Dê aos cavaleiros ligação com cavalos, aulas e progresso — sem partilhar dados sensíveis do estábulo.",
    primaryCTA: {
      label: "Solicitar acesso",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver módulos",
      href: "#features",
    },
    audience: "O EquiSight ajuda picadeiros e estábulos a manter os cavaleiros mais envolvidos e a destacarem-se digitalmente.",
    features: [
      "Tornar os cavalos do picadeiro visíveis para os cavaleiros",
      "Nome e foto por cavalo",
      "Associar cavaleiros a cavalos",
      "Acesso somente de leitura para dados sensíveis de privacidade",
      "Histórico de aulas e treinos centralizado",
      "Gestão de utilizadores com funções",
    ],
    benefits: [
      "Maior envolvimento com os cavaleiros",
      "Imagem mais profissional",
      "Serviço digital adicional para membros",
      "Nova fonte de receita através da utilização da app",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mês · funcionalidade de picadeiro incluída para cavaleiros",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Ativar Módulo Picadeiro.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Módulo de Criação",
    title: "Controle total sobre o ciclo, gestação e desenvolvimento do potro.",
    subtitle: "O módulo completo de criação para proprietárias de éguas e criadores — da cobertura ao potro, numa única linha do tempo.",
    primaryCTA: {
      label: "Ativar Módulo de Criação",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver funcionalidades",
      href: "#features",
    },
    audience: "Para criadores, proprietários de éguas e estábulos que gerem várias éguas.",
    features: [
      "Rastreamento do ciclo",
      "Registo do cio",
      "Registo de dados de inseminação",
      "Contagem regressiva para ecografias",
      "Planeamento de controlos de gestação",
      "Pedigree e linhagem",
      "Desenvolvimento do potro",
      "Visão geral de todas as éguas gestantes",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Por mês · Módulo de Criação incluído no Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Comece hoje",
      title: "Inicie a gestão da sua criação.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Módulo ferreiro",
    title: "Trabalhe de forma mais inteligente como ferreiro. Registe tudo de forma profissional.",
    subtitle: "Agenda, fotos, observações e histórico de tratamentos num único módulo — menos falhas de comunicação, dossiê mais robusto.",
    primaryCTA: {
      label: "Começar como ferreiro",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Pacote Professional",
      href: "/professional",
    },
    audience: "Para ferreiros que querem melhorar a organização, a documentação e a comunicação com clientes.",
    features: [
      "Agenda própria",
      "Compromissos por cliente",
      "Consultar perfis de cavalos",
      "Adicionar fotos antes e depois",
      "Registar tratamento",
      "Guardar conselhos e observações",
      "Notificação ETA para o cliente: \"O ferreiro está a caminho\"",
    ],
    benefits: [
      "Trabalhar de forma mais profissional",
      "Menos falhas de comunicação",
      "Melhor construção do dossiê",
      "Maior segurança em caso de responsabilidade",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mês · Módulo ferreiro incluído no Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Ativar Módulo Ferreiro.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Módulo dentário",
    title: "Um dossiê dentário completo por cavalo.",
    subtitle: "Registe descobertas, tratamentos e acompanhamento diretamente no EquiSight.",
    primaryCTA: {
      label: "Começar como dentista equino",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Pacote Professional",
      href: "/professional",
    },
    audience: "Dentistas equinos, veterinários e clínicas que pretendem trabalhar de forma estruturada.",
    features: [
      "Registar controlos dentários",
      "Descobertas por tratamento",
      "Adicionar fotografias",
      "Relatório ao proprietário",
      "Conselho de acompanhamento",
      "Histórico por cavalo",
      "Agendar nova consulta",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mês · Módulo dentário incluído no Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Ativar Módulo Dentário.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Módulo Fisio / Osteo",
    title: "Acompanhe corpo, movimento e recuperação de forma profissional.",
    subtitle: "Para fisioterapeutas e osteopatas que desejam acompanhar cavalos de forma estruturada.",
    primaryCTA: {
      label: "Começar como fisio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Pacote Professional",
      href: "/professional",
    },
    features: [
      "Ficha de admissão por cavalo",
      "Registar achados corporais",
      "Adicionar fotos e vídeos",
      "Criar relatório de tratamento",
      "Partilhar exercícios e acompanhamento",
      "Acompanhar trajetória de recuperação",
      "Histórico por cavalo",
    ],
    benefits: [
      "Melhor visão ao longo do tempo",
      "Relatórios profissionais",
      "Comunicação clara com o proprietário, treinador e cavaleiro",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mês · Módulo Fisio / Osteo incluído no Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Ativar Módulo Fisio / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Módulo de treinador",
    title: "Treine cavaleiros com dados, objetivos e progresso.",
    subtitle: "Torne o treino mensurável e o acompanhamento mais profissional — para um ou vários cavaleiros.",
    primaryCTA: {
      label: "Começar como treinador",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver pacote Pro",
      href: "/#pricing",
    },
    audience: "Para instrutores, treinadores e coaches com vários cavaleiros ou cavalos.",
    features: [
      "Vincular cavaleiros",
      "Acompanhar cavalos",
      "Definir objetivos de treino",
      "Dar feedback",
      "Analisar resultados de competição",
      "Ver progressão por combinação",
      "Usar análises de protocolo para o foco do treino",
    ],
    benefits: [
      "Melhor acompanhamento",
      "Mais estrutura",
      "Comunicação mais profissional",
      "Maior fidelização de clientes",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Por mês · Módulo de treinador incluído no Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Ativar Módulo de Treinador.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Análise de Competição",
    title: "Do protocolo à melhoria de desempenho.",
    subtitle: "Carrega o teu protocolo de competição e descobre onde estás a perder pontos — não apenas vendo a tua pontuação, mas percebendo como podes melhorar.",
    primaryCTA: {
      label: "Analisa o teu primeiro protocolo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Premium",
      href: "/premium",
    },
    features: [
      "Carregar foto do protocolo",
      "Processar frente e verso",
      "Reconhecer categoria, número de prova e juiz",
      "Analisar pontuações por elemento",
      "Resumir comentários",
      "Mostrar pontos fortes e fracos",
      "Tendências por combinação cavalo-cavaleiro",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mês · análise de competição incluída a partir do Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Começa com a análise de competição.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Pacote Professional",
    title: "Para profissionais do mundo equestre.",
    subtitle: "Ferrador, dentista, fisioterapeuta, osteopata ou treinador: colabore num único dossiê digital do cavalo.",
    primaryCTA: {
      label: "Começar como profissional",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver módulos individuais",
      href: "#features",
    },
    audience: "O Pacote Professional combina todos os módulos especializados numa única subscrição.",
    features: [
      "Módulo de Ferração",
      "Módulo de Odontologia",
      "Módulo de Fisio / Osteo",
      "Agenda e gestão de clientes",
      "Perfis de cavalos e relatórios",
      "Histórico de tratamentos e construção de dossiê",
      "Comunicação com o proprietário",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mês · todos os módulos especializados incluídos",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Escolha o Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Números de emergência para cavalos",
    title: "A ajuda certa sempre ao seu alcance.",
    subtitle: "Numa emergência, cada segundo conta. Com o EquiSight, tens todos os contactos importantes do teu cavalo sempre à mão — um toque e liga.",
    primaryCTA: {
      label: "Prepara os teus contactos de emergência",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Começa gratuitamente com o EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Contactos de emergência — liga, envia WhatsApp ou navega diretamente para o veterinário, clínica e ferrador",
      caption: "Um toque. Sem pânico.",
      embeddedFrame: true,
    },
    problem: "O teu cavalo está mal — cólica, lesão, pânico. E começa a procura. A quem liga? Tens o número certo? É este o número de urgência? Perde-se um tempo precioso.",
    solution: "Com o EquiSight tens tudo imediatamente à mão. Sem procura. Sem dúvidas. Um toque e tens contacto.",
    scenario: {
      title: "Imagina — o teu cavalo apresenta sintomas de cólica.",
      steps: [
        "Abres o EquiSight",
        "Clicas em \"Veterinário\"",
        "Liga diretamente",
      ],
      tagline: "Sem stress. Sem procura. Apenas ação.",
    },
    features: [
      "Todos os números de emergência num só lugar",
      "Ligar com um toque a partir da app",
      "Enviar WhatsApp com um toque",
      "Navegar diretamente para o endereço",
      "Lista de contactos própria por cavalo",
      "Veterinário, clínica, ferrador, dentista, fisioterapeuta",
      "Endereço + indicações de rota disponíveis de imediato",
      "Marca os números favoritos com uma estrela",
      "Números de urgência (112, 144) sempre no topo",
    ],
    benefits: [
      "Calma e controlo numa situação de emergência",
      "Todos no estábulo têm os mesmos números à mão",
      "Chega ao fim dos cartões de visita esquecidos",
      "Reage segundos mais rápido em casos urgentes",
    ],
    audience: "Para proprietários de cavalos, tratadores, treinadores e cavalariças — todos os que são responsáveis por um cavalo.",
    showcase: {
      eyebrow: "Configurado antecipadamente para ti",
      title: "13 categorias de contactos — prontas a preencher.",
      description: "Do veterinário e clínica de urgência ao seleiro, instrutor e gestor de pastagens. O EquiSight conhece o teu mundo e prepara os campos de contacto certos para ti. Toca, preenche, pronto.",
      bullets: [
        "Urgência e saúde — veterinário, urgências, clínica, linha de intoxicações",
        "Cuidados diários — ferrador, dentista, fisioterapeuta, instrutor",
        "Estábulo e pastagem — proprietário do estábulo, gestor de pastagens, pensão equestre",
        "Alimentação e materiais — fornecedores de feno, ração concentrada e palha",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Ecrã de gestão de contactos de emergência — todos os contactos sugeridos por categoria",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Lista de verificação de números de emergência para cavalos",
      items: [
        "Veterinário",
        "Clínica de urgência (24/7)",
        "Ambulância veterinária · 144",
        "Ferrador",
        "Contacto de reserva",
        "Número geral de emergência · 112",
      ],
      cta: {
        label: "Abre no EquiSight e preenche de imediato",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Números de emergência",
          price: "Gratis",
          note: "Sempre gratuito · para todos, em qualquer subscrição",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Certifica-te de que estás preparado",
      title: "Antes de ser necessário.",
      href: "/#waitlist",
    },
    microcopy: [
      "Sem compromissos",
      "Configurado em 2 minutos",
      "Sempre personalizável",
    ],
  },
};

export default LANDINGS;
